import React from 'react';
import PropTypes from 'prop-types';

import Paper from '@material-ui/core/Paper';

import { usePaperStyles } from './styles';

const WdPaper = ({ children, applicationOriented, ...rest }) => {
	const paperClasses = usePaperStyles({
		applicationOriented
	});

	return (
		<Paper {...rest} classes={paperClasses}>
			{children}
		</Paper>
	);
};

WdPaper.propTypes = {
	children: PropTypes.node.isRequired,
	applicationOriented: PropTypes.bool.isRequired
};

export default WdPaper;
